import React from "react";

const ScrollButtons = ({ scrollContainer, side, className, style }) => {
    return <i className={className} onClick={() => scrollContainer(side)} style={style}></i>;
};

export default ScrollButtons;
